module.exports = __webpack_public_path__ + "static/img/manual-2.4e6613c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-2.png
// module id = I9R2
// module chunks = 4